var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTime48Filled = function SvgIconTime48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.83 12.2a16.71 16.71 0 1 0-23.64 23.622A16.71 16.71 0 0 0 35.83 12.2Zm-7.72 18.26-4.94-5a2.85 2.85 0 0 1-.85-2v-8.47h3.4v8.27l4.8 4.79-2.41 2.41Z",
    fill: "current"
  })));
};
export default SvgIconTime48Filled;